import { useState, useEffect } from 'react';
import { User } from '../types';
import { storageService } from '../services/storageService';
import { supabase, isSupabaseConfigured } from '../services/supabaseClient';

export const useAuth = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  const refreshUser = async () => {
    const currentUser = await storageService.getCurrentUser();
    setUser(currentUser);
    setLoading(false);
  };

  useEffect(() => {
    refreshUser();

    // Listen for Supabase Auth changes if configured
    if (isSupabaseConfigured()) {
      const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
        if (session) refreshUser();
        else setUser(null);
      });
      return () => subscription.unsubscribe();
    }
  }, []);

  // CORREÇÃO: Agora aceita (User) OU (Email, Password)
  const login = async (emailOrUser: string | User, password?: string) => {
    if (typeof emailOrUser === 'string') {
        // Caso 1: Login com credenciais (vindo do App.tsx / Demo)
        try {
            const u = await storageService.login(emailOrUser, password);
            setUser(u);
        } catch (e) {
            console.error("Login falhou", e);
            throw e;
        }
    } else {
        // Caso 2: Login com objeto User (vindo do AuthPage)
        setUser(emailOrUser);
        await storageService.getCurrentUser(); 
    }
  };

  const logout = async () => {
    await storageService.logout();
    setUser(null);
  };

  return { user, loading, login, logout, refreshUser };
};